
<div class="gallery-carousel">
    <div class="logo">
        <img   src="assets/icon/gigsumologo_bigface.png"
        [routerLink]="['/landingPage']"  alt="" style="max-height: 4rem; cursor: pointer;backdrop-filter: invert(1);">
    </div>
    <div class="offThePicture" (click)="onEvent($event)">
        <span  tabindex="1" *ngIf="images.length>1" (click)="previous()">
            <ng-icon name="tablerChevronLeft"></ng-icon>
        </span>
        <span tabindex="2" *ngIf="images.length>1"(click)="next(images)" >
            <ng-icon name="tablerChevronRight"></ng-icon>
        </span>
    </div>
    <div class="carousel-image">
        <img *ngIf="images[animImage].type === 'image'" [@slide-in]="animState" (@slide-in.done)="animDone()" [src]="images[animImage].url" alt="">

        <video *ngIf="images[animImage].type === 'video'" width="100%" controls  class="hover-effect" #videoPlayer>
            <source [@slide-in]="animState" (@slide-in.done)="animDone()" [src]="images[animImage].url" />
        </video>
    </div>
    <div class="close11" title="Close" (click)="close()">
        <span class="sdwer" aria-hidden="true">&times;</span>
      </div>

</div>
